/* Copyright (c) 2016-2024 Planticle Pty Ltd */
"use strict";

var program = {
	code: "wetland",
	name: "Wetland Birds",
	description: "The Wetland Birds Program aims to research birds which utilise a variety of wetland types through population monitoring. This will support the conservation of these species and the effective management of their environment. Currently this program is only offered in Victoria, to research species presence and abundance on huntable wetlands.",
	fields: function() { return {}; },
	programData: function() { return {}; },
	visibleSharedSiteLayers: () => ['wetland'],
	defaultAreaLayer: (layers) => null,
	filterAreaLayers: (layer) => false,
	afterSelect: function(survey) {
		// Set survey type after program selected
		survey.type({
			code: 'area_search_within_500_m',
			name: '500m area search'
		});
	},
	beforeDeselect: function(survey) {
		survey.type(null);
	},
	surveyTypeOptions: [],
	hideSurveyType: false
};

export default program;
